import { b as angleInlineEnd, t as caretInlineEnd, v as angleDoubleInlineEnd, w as angleDoubleInlineStart } from './localIcons-9_jhfe7X-DyCR5FH7.js';

const angleDoubleRight = {
  ...angleDoubleInlineEnd};
const angleDoubleLeft = {
  ...angleDoubleInlineStart};
const angleRight = {
  ...angleInlineEnd,
  iconName: 'angle-right'
};
const caretRight = {
  ...caretInlineEnd,
  iconName: 'caret-right'
};

export { angleRight as a, angleDoubleRight as b, caretRight as c, angleDoubleLeft as d };
//# sourceMappingURL=classicIcons-CHpXglL2-uH6-91Kn.js.map
